export default __webpack_public_path__ + "static/media/study-lounge.b69eced0.jpg";